import { render, staticRenderFns } from "./StepLearning.vue?vue&type=template&id=718d560d&"
import script from "./StepLearning.vue?vue&type=script&lang=ts&"
export * from "./StepLearning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports